// https://stackoverflow.com/questions/25411291/angularjs-inline-check-if-an-array-check
angular.module("avlib").filter("avIsArray", function() {
	return function(input) {
		return angular.isArray(input);
	};
});
